import { defineStore } from 'pinia'
import { defaultState, defaultActions } from './_global'

export const useBarsStore = defineStore('barsStore', {
  state: () => ({
    endpoint: 'bars',
    ...defaultState
  }),
  actions: {
    ...defaultActions
  }
})
